import IndustriesSection from "@/components/IndustriesSection";
import CaseStudiesSection from "@/components/CaseStudiesSection";
import CTASection from "@/components/CTASection";
import PageHeader from "@/components/PageHeader";

export default function IndustriesPage() {
  return (
    <>
      <PageHeader
        eyebrow="/ Industries"
        title={<>Built for regulated and <span className="text-gradient">high-scale</span> environments.</>}
        copy="SaaS, healthcare, startups and retail — each with a dedicated playbook covering compliance, scale patterns and cost profiles."
      />
      <IndustriesSection />
      <CaseStudiesSection />
      <CTASection />
    </>
  );
}
